import {
  get,
  post,
  put,
  patch,
  del,
  createQueryParams,
  getLocalStorageData,
} from "../../axiosComponent";
import { serviceUrls } from "../../constant";

// Utility function for common transport data preparation
const prepareTransportData = (data = {}) => {
  const profileDetails = getLocalStorageData("profileDetails");
  return {
    ...data,
    siteId: profileDetails["_SITE"],
    regionId: profileDetails["_REGION"],
    organizationId: profileDetails["_ORGANIZATION_"]["_ID"],
  };
};

// Transport Stop Services
export const getStopList = async (data) => {
  return await get({
    url: serviceUrls.TRANSPORT_SERVICE + "/stop/list",
    params: createQueryParams(prepareTransportData(data)),
    includeOrgHeaders: true,
  });
};

export const getStop = async (entityId) => {
  return await get({
    url: serviceUrls.TRANSPORT_SERVICE + "/stop",
    params: createQueryParams({ entityId }),
    includeOrgHeaders: true,
  });
};

export const addStop = async (data) => {
  return await post({
    url: serviceUrls.TRANSPORT_SERVICE + "/stop",
    data: prepareTransportData(data),
    includeOrgHeaders: true,
  });
};

export const updateStop = async (data) => {
  return await put({
    url: serviceUrls.TRANSPORT_SERVICE + "/stop",
    data: prepareTransportData(data),
    includeOrgHeaders: true,
  });
};

export const deleteStop = async (entityId) => {
  return await del({
    url: serviceUrls.TRANSPORT_SERVICE + "/stop",
    params: createQueryParams({ entityId }),
    includeOrgHeaders: true,
  });
};

export const updateStopStatus = async (data) => {
  return await patch({
    url: serviceUrls.TRANSPORT_SERVICE + "/stop",
    params: createQueryParams(prepareTransportData(data)),
    includeOrgHeaders: true,
  });
};
